import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker'

import App from "./App";

// Polyfill defensivo: em alguns ambientes (build custom sem define plugin) process pode não existir no window
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
	window.process = { env: {} }; // evita ReferenceError em libs que acessam apenas process.env
}

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

serviceworker.register()